/**
 * @generated SignedSource<<652a9fcae0160b6c3b82aea1cccb4ed5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type userSaleQuery$variables = {};
export type userSaleQuery$data = {
  readonly userSale: {
    readonly id: string;
    readonly remaining: number;
  } | null;
};
export type userSaleQuery = {
  response: userSaleQuery$data;
  variables: userSaleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Sale",
    "kind": "LinkedField",
    "name": "userSale",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "remaining",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "userSaleQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "userSaleQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "b9e81b7ada7fea2aa39fa8e7a7dca1ed",
    "id": null,
    "metadata": {},
    "name": "userSaleQuery",
    "operationKind": "query",
    "text": "query userSaleQuery {\n  userSale {\n    id\n    remaining\n  }\n}\n"
  }
};
})();

(node as any).hash = "a559f737194b8c471c7ad1746a841873";

export default node;
